// utils/renderEditableCell.js
export const renderEditableCell = (params) => {
  const handleChange = (e) => {
    let value = parseFloat(e.target.value);
    if (isNaN(value) || value < 0) value = 0;
    params.api.setEditCellValue({ id: params.id, field: params.field, value });
  };

  return (
    <input
      type="number"
      min={0}
      step={1}
      placeholder="0"   // 👈 affiche un zéro grisé si value est vide
      value={params.value ?? ""} // 👈 si null/undefined → champ vide → placeholder visible
      onChange={handleChange}
      style={{
        width: "100%",
        padding: "4px",
        borderRadius: "4px",
        border: "1px solid #ccc",
        fontSize: "0.9rem",
        textAlign: "center"
      }}
    />
  );
};
